/*======================================================================================
*
*
*    Router
*
*
======================================================================================*/

export default (function (w, d) {
    'use strict';

    let path, routePath, x, len, key, regex, matches, part;

    function Router(options) {
        // Extending options
        this.options = _.extend({
            routes  : {},
        }, options);
        this.controller = null;

        // Scan routes and find controller
        this.getRoute();
    }

    Router.prototype.getRoute = function () {
        path = w.location.href.split('#')[0].split('?')[0].split('/');
        path.splice(0,3);

        // Assign path to the name of current page layout if it was passed into blade
        if (window.pageLayout !== undefined) {
            path = [window.pageLayout];
        }

        // Go throw all route paths and define controller
        for (key in this.options.routes){
            routePath = key.split('/');
            routePath.splice(0,1);

            // If route path length not equal to url path length
            // Skip and go forward
            if(routePath.length !== path.length){
                continue;
            }

            // Assign controller
            this.controller = this.options.routes[key];

            // Go throw each route path part
            // Compare with url path parts
            x = 0; len = routePath.length;
            for(; x < len; x++){
                // Check if route path part has parameters
                // Router accepts only one param in part (part/part/part)
                matches = routePath[x].match(/[{].*[}]/);
                if(matches){
                    // If part is one big parameter
                    if(routePath[x].match(/^[{].*[}]$/)){ continue; }

                    // Format pattern to take everything if it is in parameter position (...[param]...)
                    part = routePath[x].replace(/[{].*[}]/,'(.*)');

                    // Creating regular expretions pattern
                    regex = new RegExp('^' + part + '$');

                    // Check if url path matching pattern
                    if(!path[x].match(regex)){
                        // If not matching then unset controller
                        this.controller = null;
                    }
                } else if(routePath[x] !== path[x]){
                    // Skip whole route because its not matching
                    // Detach controller
                    this.controller = null;
                    break;
                }
            }

            // Stop checking because route path completely match url path
            if(this.controller){
                break;
            }
        }


        Router.prototype.init = function () {
            if(!this.controller){
                console.warn('======= Route is not found! ========');
                console.warn('[path]' + path.join('/'));
                console.warn('[routes]');
                console.log(this.options.routes);
                console.warn('====================================');
            } else {
                console.warn('Route: ' + routePath.join('/'));
                window.puslapis=routePath;
                new this.controller();
            }

        }
    }

    return Router;
}(window, document));

